.page {
  width: 100%;
}

/* Align the DS Header to the design's page head (`.ph`): 27px/400 title,
   -.01em tracking, 1.15 line-height, 22px block gap below. */
.header {
  height: auto;
  margin-bottom: 22px;
  align-items: flex-start;

  /* actions right-aligned, 8px gap */
  [class*="module_actions"] {
    align-self: flex-start;
    gap: var(--spacing-2);
  }
}

/* The DS `.header.size-l .headline` rule (specificity 0,3,0) forces 35px; this
   selector (0,4,0) beats it so the design's 27px title wins on every page. */
.page .header[class*="module_size"] [class*="module_headline"] {
  font-size: var(--font-size-xxl);
  font-weight: 400;
  letter-spacing: -0.01em;
  line-height: 1.15;
  color: var(--color-text);
}

/* description sits 6px under the title, then the 22px block gap follows */
.header + .description {
  margin-top: -16px;
}

.description {
  margin-bottom: 22px;
  max-width: 680px;
  color: var(--color-grey);
  font-size: var(--font-size-m);
  line-height: 1.5;
}
